if (window.location.pathname.startsWith("/products")) {
  document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll("magnet-element");

  cards.forEach((card) => {
    const variantLabels = card.querySelectorAll("label");

    variantLabels.forEach((label) => {
      label.addEventListener("click", () => {
        if (typeof BSS_B2B === "object" && BSS_B2B?.observer?.productSubject) {
          setTimeout(() => {
            BSS_B2B.observer.productSubject.notifyObserver(
              "ProductMutate",
              "ProductPriceMutate"
            );
          }, 1000);
        }
      });
    });
  });
});
}
